import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MeasurementOrFact } from '@models';

const iconMap: Record<string, string> = {
  activityEndDate: 'date_range',
  activityName: 'label',
  activityStartDate: 'date_range',
  basisOfRecord: 'label',
  class: 'label',
  cruiseNumber: 'label',
  dateIdentified: 'date_range',
  decimalLatitude: 'location_on',
  decimalLongitude: 'location_on',
  dynamicProperties: 'data_object',
  eventDate: 'date_range',
  eventID: 'badge',
  eventRemarks: 'comment',
  eventTime: 'date_range',
  expedition: 'directions_boat',
  family: 'label',
  fieldNumber: 'label',
  gearType: 'label',
  genus: 'label',
  id: 'badge',
  identificationRemarks: 'comment',
  identificationQualifier: 'badge',
  identifiedBy: 'person',
  kingdom: 'label',
  lifeStage: 'label',
  locationID: 'location_on',
  magnificationMicroscope: 'label',
  modified: 'date_range',
  niskinNumbers: 'label',
  occurrenceCount: 'bar_chart',
  occurrenceID: 'badge',
  occurrenceRemarks: 'comment',
  occurrenceStatus: 'label',
  order: 'label',
  organismQuantityType: 'straighten',
  organismRemarks: 'comment',
  parentEventID: 'badge',
  phylum: 'label',
  principalInvestigatorEmail: 'person',
  principalInvestigatorInstitution: 'person',
  principalInvestigatorName: 'person',
  recordedBy: 'person',
  sampleRemarks: 'comment',
  sampleSizeUnit: 'straighten',
  sampleStatus: 'label',
  sampleType: 'label',
  samplingProtocol: 'menu_book',
  scientificName: 'label',
  scientificNameID: 'badge',
  vessel: 'directions_boat',
  wikiDataURL: 'link',
  // origin only:
  created: 'date_range',
  createdBy: 'person',
  darwinCoreClass: 'category',
  inputDataURL: 'link',
  isPublished: 'visibility',
  numberOfItems: 'bar_chart',
  planktonType: 'category',
  sourceType: 'category',
  gitDate: 'date_range',
  gitHash: 'badge',
  gitURL: 'link',
  googleDocumentTitle: 'label',
  googleSheetID: 'badge',
  googleSpreadsheetID: 'badge',
  googleTabName: 'label',
  googleURL: 'link',
  sourceScript: 'terminal',
  sourceFileName: 'insert_drive_file',
  sourceMimeType: 'label',
};

@Component({
  selector: 'app-plankton-propertylist',
  templateUrl: './propertylist.component.html',
  styleUrls: ['./propertylist.component.scss'],
  imports: [CommonModule, MatIconModule, MatListModule, RouterModule],
})
export class PlanktonPropertyListComponent {
  readonly data = input<unknown>();
  readonly title = input<string>();

  icon(key: string) {
    return iconMap[key] || 'timeline';
  }

  properties = computed(() => this.data() as Map<string, unknown>);

  mofItem(obj: unknown): MeasurementOrFact | undefined {
    if (typeof obj !== 'object') {
      return undefined;
    }
    const maybe = obj as MeasurementOrFact;
    if (typeof maybe['value'] === 'undefined') {
      return undefined;
    }
    return maybe;
  }

  mofValue(mof: MeasurementOrFact): string {
    if (!Array.isArray(mof.value)) {
      return mof.value + ' ' + (mof.unit || '');
    }
    return mof.value.map((v: string) => v + ' ' + (mof.unit || '')).join(', ');
  }
}
